const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgImgNoDataDark(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 297.828,
    height: 179.913,
    viewBox: "0 0 297.828 179.913",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 1203",
    transform: "translate(109.414 1.5)",
    style: {
      strokeLinecap: "round",
      strokeLinejoin: "round",
      stroke: "#d5d7dc",
      strokeWidth: 3,
      fill: "#222"
    },
    d: "M0 0h104v144H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 872",
    d: "M209.284 174.854v120.212h-104v-142h81.544z",
    transform: "translate(-5.87 -135.567)",
    style: {
      strokeDasharray: "6 6",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      stroke: "#d5d7dc",
      strokeWidth: 3,
      fill: "#222"
    }
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "\\uADF8\\uB8F9 1673"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC120 278",
    style: {
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      stroke: "#d5d7dc",
      strokeWidth: 3
    },
    d: "M16 0 0 16",
    transform: "translate(119.414 55.498)"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC120 279",
    style: {
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      stroke: "#d5d7dc",
      strokeWidth: 3
    },
    d: "M16 16 0 0",
    transform: "translate(119.414 55.498)"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "\\uADF8\\uB8F9 1674"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC120 280",
    style: {
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      stroke: "#d5d7dc",
      strokeWidth: 3
    },
    d: "M16 0 0 16",
    transform: "translate(167.414 55.498)"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC120 281",
    style: {
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      stroke: "#d5d7dc",
      strokeWidth: 3
    },
    d: "M16 16 0 0",
    transform: "translate(167.414 55.498)"
  })), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 873",
    d: "M119.284 188.26s3.112-10 16.3-10 15.7 10 15.7 10",
    transform: "translate(16.13 -95.761)",
    style: {
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      stroke: "#d5d7dc",
      strokeWidth: 3
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 874",
    d: "M136.647 153.431v22h22",
    transform: "translate(43.767 -134.933)",
    style: {
      fill: "none",
      strokeDasharray: "6 6",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      stroke: "#d5d7dc",
      strokeWidth: 3
    }
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "\\uADF8\\uB8F9 1675"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC120 282",
    style: {
      stroke: "#eaecf0",
      strokeWidth: 2,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    },
    d: "M10 0 0 10",
    transform: "translate(231.414 36.498)"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC120 283",
    style: {
      stroke: "#eaecf0",
      strokeWidth: 2,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    },
    d: "M10 10 0 0",
    transform: "translate(231.414 36.498)"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "\\uADF8\\uB8F9 1676"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC120 284",
    style: {
      stroke: "#eaecf0",
      strokeWidth: 2,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    },
    d: "M10 0 0 10",
    transform: "translate(60.414 125.499)"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC120 285",
    style: {
      stroke: "#eaecf0",
      strokeWidth: 2,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    },
    d: "M10 10 0 0",
    transform: "translate(60.414 125.499)"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "\\uADF8\\uB8F9 1677"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC120 286",
    style: {
      stroke: "#eaecf0",
      strokeWidth: 2,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    },
    d: "M10 0 0 10",
    transform: "translate(1.414 122.499)"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC120 287",
    style: {
      stroke: "#eaecf0",
      strokeWidth: 2,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    },
    d: "M10 10 0 0",
    transform: "translate(1.414 122.499)"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "\\uADF8\\uB8F9 1678"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC120 288",
    style: {
      stroke: "#eaecf0",
      strokeWidth: 2,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    },
    d: "M10 0 0 10",
    transform: "translate(270.414 127.499)"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC120 289",
    style: {
      stroke: "#eaecf0",
      strokeWidth: 2,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    },
    d: "M10 10 0 0",
    transform: "translate(270.414 127.499)"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "\\uADF8\\uB8F9 1679"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC120 290",
    style: {
      stroke: "#eaecf0",
      strokeWidth: 2,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    },
    d: "M10 0 0 10",
    transform: "translate(20.414 40.299)"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC120 291",
    style: {
      stroke: "#eaecf0",
      strokeWidth: 2,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    },
    d: "M10 10 0 0",
    transform: "translate(20.414 40.299)"
  })), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC120 292",
    transform: "translate(38.414 1.5)",
    style: {
      stroke: "#eaecf0",
      strokeWidth: 2,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    },
    d: "M32 0 0 32"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC120 293",
    transform: "translate(19.414 64.1)",
    style: {
      stroke: "#eaecf0",
      strokeWidth: 2,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    },
    d: "M52 0 0 52"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC120 294",
    transform: "translate(244.414 48.499)",
    style: {
      stroke: "#eaecf0",
      strokeWidth: 2,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    },
    d: "M52 0 0 52"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC120 295",
    transform: "translate(228.413 148.498)",
    style: {
      stroke: "#eaecf0",
      strokeWidth: 2,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    },
    d: "M30 0 0 30"
  }));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgNoDataDark);
export default __webpack_public_path__ + "static/media/img-no-data-dark.f330d9db66e3c8a02e48c39a33f0a4a4.svg";
export { ForwardRef as ReactComponent };